import styled from 'styled-components';
import {
  DialogContent as MaterialDialogContent,
  TextField as MaterialTextField,
  Dialog as MaterialDialog,
  DialogActions as MaterialDialogActions,
  Button as MaterialButton,
  Card as MaterialCard,
  CardHeader as MaterialCardHeader,
} from '@material-ui/core';

export const Dialog = styled(MaterialDialog)``;

export const Container = styled.div``;

export const DialogContent = styled(MaterialDialogContent)`
  width: 500px !important;
`;

export const InputTextarea = styled(MaterialTextField)`
  width: 100%;
  height: 100%;
  color: white;
`;

export const DialogActions = styled(MaterialDialogActions)`
  padding: 0px 0px 8px 0px !important;
`;

export const CloseButton = styled(MaterialButton)`
  width: 30%;
  background-color: #e05100 !important;
  color: #ffffff !important;
`;

export const ActionsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;

  & > * {
    margin: auto !important;
  }
`;

export const Card = styled(MaterialCard)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const CardHeader = styled(MaterialCardHeader)``;

export const FormDiv = styled.div`
  margin: 0 15px 15px 15px;
`;
